import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UzurvPipesModule } from '@uzurv/core';
import { DotsDirectivesModule } from '@uzurv/dots';
import { SelectDriverListItemComponent } from './select-driver-list-item';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    DotsDirectivesModule,
    UzurvPipesModule
  ],
  declarations: [SelectDriverListItemComponent],
  exports: [SelectDriverListItemComponent]
})
export class SelectDriverModule {}
